import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MemberAttendance  {
    _originalTypeClassName = "zERP.BO.MemberAttendance";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MemberAttendance.translate = translateService;
}
this.Id = null;
this.IsComing = false;
this.HasCancelled = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsComing:any;
HasCancelled:any;
Meeting:any;
Attendee:any;
static setMeeting = ($this, value) => {
var oldValue = $this.Meeting;
$this.Meeting = value;
if (value != null) {
if (oldValue != null) {
Domain.PartyMeeting.removeMembersAttending(oldValue, $this);
}
Domain.PartyMeeting.addMembersAttending(value, $this);
}
}
static setAttendee = ($this, value) => {
var oldValue = $this.Attendee;
$this.Attendee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeMeetingToAttend(oldValue, $this);
}
Domain.Employee.addMeetingToAttend(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}